import { useDispatch, useSelector } from 'react-redux';
import { updateSelectedAccount, SteamAccount } from '../../store/slices/authSlice';
import { RootState } from '../../store';
import React from 'react';
import SteamAccountSelect from '../utils/SteamAccountSelect';
import api from '../../api/axios';

const NavBarSteamAccountSelect = () => {
  const dispatch = useDispatch();

  const selectedSteamAccount = useSelector((state: RootState) => state.auth.selectedSteamAccount);

  async function handleAccountChange(steamAccount: SteamAccount | null) {
    if (!steamAccount) return;

    try {
      await api.patch(`/user/steam-account/${steamAccount.id}/favorite`);
      localStorage.setItem('selectedSteamAccountId', steamAccount.id.toString());
      dispatch(updateSelectedAccount(steamAccount));
    } catch (err) {
      console.error("Fehler beim Favoriten-Wechsel", err);
    }
  }

  return (
      <div className="block w-44 md:w-44">
        <SteamAccountSelect
            value={selectedSteamAccount}
            size="small"
            variant="outlined"
            onChange={(acc) => handleAccountChange(acc)}
        />
      </div>
  );
};

export default NavBarSteamAccountSelect;